import classNames from 'classnames';
import React from 'react';
import { IconProps } from '../types/icon';
import styles from './icon.module.sass';

export function IconYoutube({ className }: IconProps) {
  return (
    <svg
      className={classNames(styles.icon, className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <title>Youtube</title>
      <path
        d="M20.8221 8.39948C20.8221 8.39948 20.6464 7.15847 20.105 6.61355C19.4194 5.89636 18.6531 5.89285 18.3015 5.85066C15.7843 5.66785 12.005 5.66785 12.005 5.66785H11.9979C11.9979 5.66785 8.21865 5.66785 5.70146 5.85066C5.3499 5.89285 4.5835 5.89636 3.89795 6.61355C3.35654 7.15847 3.18428 8.39948 3.18428 8.39948C3.18428 8.39948 3.00146 9.85845 3.00146 11.3139V12.6779C3.00146 14.1335 3.18076 15.5924 3.18076 15.5924C3.18076 15.5924 3.35654 16.8335 3.89443 17.3783C4.57998 18.0955 5.47998 18.0709 5.88076 18.1483C7.32217 18.2854 12.0015 18.3275 12.0015 18.3275C12.0015 18.3275 15.7843 18.3205 18.3015 18.1412C18.6531 18.0991 19.4194 18.0955 20.105 17.3783C20.6464 16.8335 20.8221 15.5924 20.8221 15.5924C20.8221 15.5924 21.0015 14.1369 21.0015 12.6779V11.3139C21.0015 9.85845 20.8221 8.39948 20.8221 8.39948ZM10.1417 14.3338V9.27487L15.0038 11.8131L10.1417 14.3338Z"
        fill="black"
      />
    </svg>
  );
}
